import script from "./PlayStore.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlayStore.vue?vue&type=script&setup=true&lang=ts"

import "./PlayStore.vue?vue&type=style&index=0&id=7dc06577&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dc06577"]])

export default __exports__